import { AUL_REG_PATH, LKU_CHOOSE_SIGN_REG_PATH, USER_DATA_REG_PATH, } from "../constants/routes.constants";
import { RegistrationStages, RetrieveApp } from "../types/api/crm.types";
export const REGISTRATION_STAGES = {
    userData: RegistrationStages.UserData,
    chooseSign: RegistrationStages.ChooseSign,
    questionareLegalEntity: RegistrationStages.QuestionareLegalEntity,
    registrationFinished: RegistrationStages.RegistrationFinished,
};
const resolveStage = (stages) => {
    const navigate = window.singleSpaNavigate;
    const path = window.location.pathname;
    const commonOnboarding = stages?.find(stage => stage.application === RetrieveApp.Common);
    const lkuOnboarding = stages?.find(stage => stage.application === RetrieveApp.Lku);
    if (!stages || !stages?.length || !commonOnboarding) {
        navigate(USER_DATA_REG_PATH);
    }
    if (path === LKU_CHOOSE_SIGN_REG_PATH && lkuOnboarding?.stage === RegistrationStages.QuestionareLegalEntity) {
        navigate(AUL_REG_PATH);
    }
};
export const handleGetRegistrationStep = async (httpClient) => {
    try {
        const res = await httpClient.get("/shared/registration/stages/application/retrieve");
        const data = res.data?.data;
        resolveStage(data);
        return res.data;
    }
    catch (e) {
        if (e?.response?.status !== 401) {
            document.body.innerHTML = `
        <div class="error-flex">
          <img src="/img/404.png" />
          <div class="error-block">
            <p class="error-title">
              Не удалось загрузить данные для входа. Пожалуйста, попробуйте позже или обратитесь в службу поддержки
            </p>
          </div>
        </div>
      `;
        }
        console.error("Can't get registration step");
        throw e;
    }
};
